<ngxh6-toast-container></ngxh6-toast-container>

@if (user.watch | async; as _user) { @if (_user.loggedIn) {
<app-navbar></app-navbar>
<app-support-widget></app-support-widget>
}
<router-outlet></router-outlet>
@if (showRequests) {
<ngxh6-requests></ngxh6-requests>
} @if (!online) {
<div class="offline-banner">
    <div class="inner">{{ user.simulating_offline ? '(Simulating) ' : '' }}Offline - Features may be unavailable</div>
</div>
}
<div class="demo-ribbon" [class.demo-ribbon--page]="!_user.loggedIn" role="note" aria-label="Demonstration only. All names and figures are fictional.">
    <span class="demo-ribbon-tag">Demo</span>
    <span class="demo-ribbon-text">Demonstration only &mdash; all names and figures are fictional</span>
</div>
}

